module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QUKCCwtxGxr8AAAACdJREFUOMtj/P//PwMlgImBQjDwBjD+T2P4P8LDYNQABgbG0bzAAACmAwh86OglIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_acometida_enterrada.png
// module id = 7ftv
// module chunks = 0